/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { moreListTooltipStyles } from '@constants/mui-theme';
import CountAvatar from '@shared/count-avatar';
import { getAgencyIcon, renderCustomIconAndLabel } from '@utils/icon-utils';
import './conflict-agencies.scss';

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    ...moreListTooltipStyles.tooltip,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
  }
}));

const ConflictAgencies = ({ agencies, agencyTypes, conflict }) => {
  const classes = useStyles();
  const [anchorPosition, setAnchorPosition] = useState(null);

  const handleMouseEnter = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setAnchorPosition(null);
  }, []);

  const handleMouseMove = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const open = Boolean(anchorPosition);

  const getIcon = agencyId => {
    const agency = agencies[agencyId];
    if (agency) {
      const agencyType = agencyTypes[agency.type];
      const icon = getAgencyIcon(agencyType);
      return (
        <Tooltip title={agency.name}>
          <img src={icon} alt="" styleName="item" />
        </Tooltip>
      );
    }
    return null;
  };

  const renderItem = (agencyId, index) => {
    const agency = agencies[agencyId];
    if (agency) {
      return (
        <div key={index} styleName="tooltip-item">
          {renderCustomIconAndLabel(agency.name, getIcon(agencyId))}
        </div>
      );
    }
    return null;
  };

  const renderList = list => (
    <div>
      {list.slice(0, 5).map((agencyId, index) => renderItem(agencyId, index))}
      {list.length > 5 && (
        <div style={moreListTooltipStyles.seeDetailsStyle}>
          See overlaps detail for complete list
        </div>
      )}
    </div>
  );

  const renderAvatar = (list, value) => (
    <div
      onMouseOver={handleMouseEnter}
      onMouseOut={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <CountAvatar count={value} />
      <Popover
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition || { top: 0, left: 0 }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        disableRestoreFocus
      >
        {renderList(list)}
      </Popover>
    </div>
  );

  const agencyList = conflict.agencies;
  if (!agencyList) {
    return null;
  }
  const list = agencyList.split(',');

  return (
    <div styleName="column-renderer-conflict-agencies-container">
      {list.slice(0, 5).map(agencyId => getIcon(agencyId))}
      {list.length > 5 && renderAvatar(list.slice(5), `+${list.length - 5}`)}
    </div>
  );
};

ConflictAgencies.propTypes = {
  agencies: PropTypes.object,
  agencyTypes: PropTypes.object,
  conflict: PropTypes.object
};

export default ConflictAgencies;
